import { loadSite, loadWorks, url } from "./api";
import { bindSiteText, escapeHtml, featuredWorks, renderMedia } from "./render";

export async function initHome(): Promise<void> {
  const wall = document.getElementById("muro");
  if (!wall) return;

  const [site, works] = await Promise.all([loadSite(), loadWorks()]);
  bindSiteText(site as unknown as Record<string, string>);

  const featured = featuredWorks(works);
  const rest = works.filter((work) => !featured.some((item) => item.id === work.id));
  const ordered = [...featured, ...rest];

  const tiles = ordered.flatMap((work) =>
    work.media
      .filter((item) => item.type === "image")
      .map(
        (item) => `<a class="tile" href="${url(`trabajo.html?id=${encodeURIComponent(work.id)}`)}">
          ${renderMedia(item)}
          <span class="tile-caption">${escapeHtml(work.title)}</span>
        </a>`
      )
  );

  wall.insertAdjacentHTML("beforeend", tiles.join(""));
}
